import { render, staticRenderFns } from "./AnnotationCircle.vue?vue&type=template&id=236c1e8a&"
import script from "./AnnotationCircle.vue?vue&type=script&lang=js&"
export * from "./AnnotationCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports